export const PERFIL_AGENCIA_CAMPOS_REQUERIDOS = [
  "nombre",
  "nombre_fiscal",
  "responsable",
  "cif",
  "telefono",
  "email",
  "direccion",
  "cod_postal",
  "poblacion",
  "provincia",
  "pais",
  "direccion_fiscal",
  "cod_postal_fiscal",
  "poblacion_fiscal",
  "provincia_fiscal",
  "pais_fiscal",
];

export function campoPerfilAgenciaValido(valor) {
  return valor !== null && valor !== undefined && String(valor).trim() !== "";
}

export function perfilAgenciaCompleto(origen) {
  if (!origen) return false;

  return PERFIL_AGENCIA_CAMPOS_REQUERIDOS.every((campo) =>
    campoPerfilAgenciaValido(origen[campo])
  );
}
